import React from 'react';
import PropTypes from 'prop-types';
import VoucherEntry from '../components/VoucherEntry';
import Translate from '../components/Translate';
import {WEB} from '../constants/SalesChannels';
import actionstype from '../types/actions';
import errorstype from '../types/errors';

const VoucherEntryContainer = ({
  actions,
  errors,
  paymentSelected,
  salesChannel,
  voucher,
  voucherSupported,
  prepaidVoucher,
  timeoutModal,
}) => {
  if (salesChannel === WEB) {
    return (
      <VoucherEntry
        errors={errors}
        paymentSelected={paymentSelected}
        prepaidVoucher={prepaidVoucher}
        updateVoucherCode={actions.updateVoucherCode}
        updateVoucherFromBackend={actions.updateVoucherFromBackend}
        voucher={voucher}
        voucherSupported={voucherSupported}
        timeoutModal={timeoutModal}
      />
    );
  }
  if (!paymentSelected && salesChannel === WEB) {
    return (
      <div className="message message--info voucher-entry__message">
        <Translate content="Discount codes and gift cards cannot be used with this payment method." />
      </div>
    );
  }

  return (
    <div className="message message--info voucher-entry__message">
      <Translate content="Discount codes and gift cards cannot be used with travel partner." />
    </div>
  );
};

VoucherEntryContainer.propTypes = {
  actions: actionstype,
  errors: errorstype,
  paymentSelected: PropTypes.bool.isRequired,
  prepaidVoucher: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    currencyCode: PropTypes.string.isRequired,
  }),
  salesChannel: PropTypes.string.isRequired,
  voucher: PropTypes.shape({
    agencyRef: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    campaignName: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
  voucherSupported: PropTypes.bool.isRequired,
  timeoutModal: PropTypes.object.isRequired,
};

export default VoucherEntryContainer;
